import { render, staticRenderFns } from "./link-icon-component.vue?vue&type=template&id=7e3467da&scoped=true"
import script from "./link-icon-component.ts?vue&type=script&lang=ts&external"
export * from "./link-icon-component.ts?vue&type=script&lang=ts&external"
import style0 from "./link-icon-component.scss?vue&type=style&index=0&id=7e3467da&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3467da",
  null
  
)

export default component.exports